import { baseUrl } from './general-api';
/**
 * API to sing in and check user data
 */

export interface Userinfo {
  properties?: UserProperties;
  groupList?: GroupsList;
}

export interface UserProperties {
  uid?: string;
  isWebshopUser?: boolean | string;
}

export interface GroupsList {
  list?: string[];
}

let checkLoginPromise: Promise<Userinfo> | null = null;

export const checkLogin = (): Promise<Userinfo> => {
  if (checkLoginPromise) {
    return checkLoginPromise;
  }

  const url = baseUrl + '/.oauth/userinfo';

  checkLoginPromise = fetch(url.toString())
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(() => {
      checkLoginPromise = null;
      return {};
    });

  return checkLoginPromise;
};

/**
 * Whether the given userinfo identifies a webshop user.
 */
export const isWebshopUser = (userinfo: Userinfo | null | undefined): boolean => {
  const value = userinfo?.properties?.isWebshopUser;
  return value === true || value === 'true';
};

/**
 * Sets or removes the `is-webshop-user` class on <html> based on the userinfo endpoint.
 * Pin and cart header buttons are only shown when this class is present.
 */
export const applyWebshopUserClass = async (): Promise<boolean> => {
  const result = await checkLogin();
  const webshopUser = isWebshopUser(result);
  document.documentElement.classList.toggle('is-webshop-user', webshopUser);
  return webshopUser;
};

export const login = async (action: string, csrf?: string, email?: string, password?: string): Promise<any> => {
  const params = {
    csrf,
    mgnlRealm: 'external',
    mgnlUserId: email,
    mgnlUserPSWD: password
  };
  const searchParams = new URLSearchParams(params).toString();
  return fetch(action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: searchParams
  });
};
